module.exports = __webpack_public_path__ + "static/media/ic-navigation-right.091bf8d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/ic-navigation-right.svg
// module id = 1069
// module chunks = 0